<template>
  <div class="inner">
      <div
        class="mt-5"
        id="partnerDrawing-parent">
          <div class="card">
            <div class="accordion card-header d-flex justify-content-between" id="partnerDrawing-header" data-toggle="collapse" data-target="#partnerDrawing" :aria-expanded="false" aria-controls="partnerDrawing">
              <h3 class="mb-0">{{ $t('取引先') }}</h3>
              <div class="accordion-toggle-btn">
                <b-button block id="partnerDrawing-up">{{ $t('閉じる') }}</b-button>
                <b-button block id="partnerDrawing-down">{{ $t('開く') }}</b-button>
              </div>
            </div>
            <div id="partnerDrawing" class="collapse" aria-labelledby="partnerDrawing-header" data-parent="#partnerDrawing-parent">
              <div class="card-body">
                <table class="table table-bordered">
                  <thead>
                    <th class="text-left w-15">{{$t('取引先名')}}</th>
                    <th class="text-left w-15">{{$t('管理番号')}}</th>
                    <th class="text-left w-20">{{$t('客先品番')}}</th>
                    <th class="text-left w-10">{{$t('売単価')}}</th>
                    <th class="text-left w-10">{{$t('仕入単価')}}</th>
                    <th class="text-left w-15">{{$t('備考')}}</th>
                    <th class="text-left w-15" colspan="2"></th>
                  </thead>
                  <tbody class="tbody">
                    <tr v-for="(item, index) in partnerList" :key="index">
                      <td>
                        <template v-if="item.partnerName">
                          {{ item.partnerName }}
                        </template>
                        <template v-else>-</template>
                      </td>
                      <td>
                        <template v-if="item.partnerCode">
                          {{ item.partnerCode }}
                        </template>
                        <template v-else>-</template>
                      </td>
                      <td>
                        <template v-if="item.partnerProductCode">
                          {{ item.partnerProductCode }}
                        </template>
                        <template v-else>-</template>
                      </td>
                      <td>
                        <template v-if="item.salesPrice">
                          {{ item.salesPrice | mixinCommaDisplay }}&nbsp;{{ $t('円') }}
                        </template>
                        <template v-else>-</template>
                      </td>
                      <td>
                        <template v-if="item.purchasePrice">
                          {{ item.purchasePrice | mixinCommaDisplay }}&nbsp;{{ $t('円') }}
                        </template>
                        <template v-else>-</template>
                      </td>
                      <td>
                        <template v-if="item.note">
                          {{ item.note }}
                        </template>
                        <template v-else>-</template>
                      </td>
                      <td>
                        <button
                          type="button"
                          class="btn btn-light create-btn"
                          @click="partnerFixModalOpen(item)"
                        >
                          {{ $t('編集') }}
                        </button>
                      </td>
                      <td>
                        <button
                          type="button"
                          class="btn btn-danger create-btn"
                          @click="deleteAlert(item, 'partner')"
                        >
                          {{ $t('削除') }}
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between mt-3 mb-5">
          <button
            type="button"
            class="btn btn-success create-btn"
            @click="partnerAddModalOpen()"
          >
            {{ $t('取引先登録') }}
          </button>
        </div>
        <div class="d-flex justify-content-start align-items-baseline mt-5 mb-3 form-group">
          <h4 class="mr-3">{{ $t('取引先') }}</h4>
          <select v-model.number="selectPartner" class="form-control wf-120">
            <option value=""></option>
            <option v-for="(item,index) in partnerList" :value="item.partnerId" :key="`partner-select-${index}`">{{ item.partnerName }}</option>
          </select>
        </div>
        <div
        class="mt-5"
        id="partnerHistoryDrawing-parent">
          <div class="card">
            <div class="accordion card-header d-flex justify-content-between" id="partnerHistoryDrawing-header" data-toggle="collapse" data-target="#partnerHistoryDrawing" :aria-expanded="false" aria-controls="partnerHistoryDrawing">
              <h3 class="mb-0">{{ $t('売単価/仕入単価変更履歴') }}</h3>
              <div class="accordion-toggle-btn">
                <b-button block id="partnerHistoryDrawing-up">{{ $t('閉じる') }}</b-button>
                <b-button block id="partnerHistoryDrawing-down">{{ $t('開く') }}</b-button>
              </div>
            </div>
            <div id="partnerHistoryDrawing" class="collapse" aria-labelledby="partnerHistoryDrawing-header" data-parent="#partnerHistoryDrawing-parent">
              <div class="card-body">
                <table class="table table-bordered">
                  <thead>
                    <!-- <tr>
                      <th class="table-active text-left" colspan="8">{{$t('売単価/仕入単価変更履歴')}}</th>
                    </tr> -->
                    <tr>
                      <th class="text-left w-12">{{$t('適用日時')}}</th>
                      <th class="text-left w-20">{{$t('取引先名')}}</th>
                      <th class="text-left w-12">{{$t('変更前')}}</th>
                      <th class="text-left w-12">{{$t('変更後')}}</th>
                      <th class="text-left w-12">{{$t('差額')}}</th>
                      <th class="text-left w-15" colspan="2"></th>
                    </tr>
                  </thead>
                  <tbody class="tbody">
                    <template v-for="(item,index) in changeHistories">
                      <tr :key="index">
                        <td rowspan="2">
                          <template v-if="item.startDatetime">
                            {{ mixinTimestampToFormat(item.startDatetime,'YYYY/MM/DD HH:mm') }}
                          </template>
                          <template v-else>
                            -
                          </template>
                        </td>
                        <td rowspan="2">
                          <template v-if="item.partnerName">
                            {{ item.partnerName }}
                          </template>
                          <template v-else>
                            -
                          </template>
                        </td>
                        <td>
                          <template v-if="item.beforeSalesPrice">
                            {{ item.beforeSalesPrice | mixinCommaDisplay }}&nbsp;{{$t('円')}}
                          </template>
                          <template v-else>
                            -
                          </template>
                        </td>
                        <td>
                          <template v-if="item.salesPrice">
                            {{ item.salesPrice | mixinCommaDisplay }}&nbsp;{{$t('円')}}
                          </template>
                          <template v-else>
                            -
                          </template>
                        </td>
                        <td v-if="!item.salesPrice || !item.beforeSalesPrice">-</td>
                        <td v-else-if="(item.salesPrice - item.beforeSalesPrice) > 0" class="text-primary">
                          +{{ (item.salesPrice - item.beforeSalesPrice) | mixinCommaDisplay }}&nbsp;{{$t('円')}}
                        </td>
                        <td v-else-if="(item.salesPrice - item.beforeSalesPrice) < 0" class="text-danger">
                          {{ (item.salesPrice - item.beforeSalesPrice) | mixinCommaDisplay }}&nbsp;{{$t('円')}}
                        </td>
                        <td v-else>{{ (item.salesPrice - item.beforeSalesPrice) | mixinCommaDisplay }}&nbsp;{{$t('円')}}</td>
                        <td rowspan="2">
                          <button
                            type="button"
                            class="btn btn-light create-btn"
                            @click="partnerFixModalOpen(item)"
                          >
                            {{ $t('詳細') }}
                          </button>
                        </td>
                        <td rowspan="2">
                          <button
                            type="button"
                            class="btn btn-danger create-btn"
                            @click="deleteAlert(item, 'history')"
                          >
                            {{ $t('削除') }}
                          </button>
                        </td>
                      </tr>
                      <tr :key="`${index}-2`">
                        <td>
                          <template v-if="item.beforePurchasePrice">
                            {{ item.beforePurchasePrice | mixinCommaDisplay }}&nbsp;{{$t('円')}}
                          </template>
                          <template v-else>
                            -
                          </template>
                        </td>
                        <td>
                          <template v-if="item.purchasePrice">
                            {{ item.purchasePrice | mixinCommaDisplay }}&nbsp;{{$t('円')}}
                          </template>
                          <template v-else>
                            -
                          </template>
                        </td>
                        <td v-if="!item.purchasePrice || !item.beforePurchasePrice">-</td>
                        <td v-else-if="(item.purchasePrice - item.beforePurchasePrice) > 0" class="text-danger">
                          +{{ (item.purchasePrice - item.beforePurchasePrice) | mixinCommaDisplay }}&nbsp;{{$t('円')}}
                        </td>
                        <td v-else-if="(item.purchasePrice - item.beforePurchasePrice) < 0" class="text-primary">
                          {{ (item.purchasePrice - item.beforePurchasePrice) | mixinCommaDisplay }}&nbsp;{{$t('円')}}
                        </td>
                        <td v-else>{{ (item.purchasePrice - item.beforePurchasePrice) | mixinCommaDisplay }}&nbsp;{{$t('円')}}</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    productId: {
      type: Number,
      required: true,
      default: 0,
    },
    productPartners: {
      type: Array,
      required: true,
      default: () => [],
    },
    histories: {
      type: Array,
      required: true,
      default: () => [],
    },
    type: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      selectPartner: null,
    }
  },
  async mounted() {
    const up = document.getElementById('partnerDrawing-up')
    const down = document.getElementById('partnerDrawing-down')
    up.classList.add('is-hide')
    down.classList.add('is-show')
    $('#partnerDrawing').on('show.bs.collapse', function() {
      const up = document.getElementById('partnerDrawing-up')
      const down = document.getElementById('partnerDrawing-down')
      up.classList.add('is-show')
      up.classList.remove('is-hide')
      down.classList.remove('is-show')
      down.classList.add('is-hide')
    })
    $('#partnerDrawing').on('hide.bs.collapse', function() {
      const up = document.getElementById('partnerDrawing-up')
      const down = document.getElementById('partnerDrawing-down')
      up.classList.remove('is-show')
      up.classList.add('is-hide')
      down.classList.add('is-show')
      down.classList.remove('is-hide')
    })
    const up_history = document.getElementById('partnerHistoryDrawing-up')
    const down_history = document.getElementById('partnerHistoryDrawing-down')
    up_history.classList.add('is-hide')
    down_history.classList.add('is-show')
    $('#partnerHistoryDrawing').on('show.bs.collapse', function() {
      const up = document.getElementById('partnerHistoryDrawing-up')
      const down = document.getElementById('partnerHistoryDrawing-down')
      up.classList.add('is-show')
      up.classList.remove('is-hide')
      down.classList.remove('is-show')
      down.classList.add('is-hide')
    })
    $('#partnerHistoryDrawing').on('hide.bs.collapse', function() {
      const up = document.getElementById('partnerHistoryDrawing-up')
      const down = document.getElementById('partnerHistoryDrawing-down')
      up.classList.remove('is-show')
      up.classList.add('is-hide')
      down.classList.add('is-show')
      down.classList.remove('is-hide')
    })
  },
  methods: {
    partnerAddModalOpen() {
      this.$emit('partnerAddModalOpen', this.type)
    },
    partnerFixModalOpen(item = {}) {
      this.$emit('partnerFixModalOpen', {type: this.type, item: item})
    },
    async deleteAlert(item, status) {
      const confirm = await this.$swal({
        text: this.$t('削除して本当によろしいでしょうか？'),
        className: 'swal-none',
        buttons: {
          cancel: {
            text: this.$t('キャンセル'),
            value: null,
            visible: true,
            className: 'btn-light',
            closeModal: true,
          },
          confirm: {
            text: 'OK',
            value: true,
            visible: true,
            className: 'btn-danger',
            closeModal: false,
          },
        },
        dangerMode: true,
      })
      if (confirm) {
        let url = ''
        if (status === 'partner') {
          url = `${this.$appConfig.CommonApiUrl}/product/partner`
        } else if (status === 'history') {
          url = `${this.$appConfig.CommonApiUrl}/product/partner/history`
        }
        try {
          await this.$axios.delete(
            url,
            {
              params: {id: item.id},
              headers: {
                Authorization: this.authorization ? this.authorization : null,
              },
            }
          )
          this.$toasted.success('データ削除完了メッセージ')
          this.initPartner()
        } catch (err) {
          this.$toasted.show('データ削除エラーメッセージ')
        }
        this.$swal.close()
      }
    },
    initPartner() {
      this.$emit('initPartner')
    },
  },
  computed: {
    // 取引先の履歴のセレクトが変わるたびに表示を変更させる
    changeHistories() {
      if (!this.histories) return []
      if (!this.histories.length) return []
      if (!this.selectPartner) return this.histories
      return this.histories.filter(item => item.partnerId === this.selectPartner)
    },
    partnerList() {
      if (this.productPartners.length === 0) return []
      return this.productPartners
    },
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
  },
  watch: {
    'productPartners': {
      handler: function(newVal) {
        if (newVal.length === 0) {
          $('#partnerDrawing').collapse('hide')
        } else if (this.partnerList.length === 0) {
          $('#partnerDrawing').collapse('hide')
        } else {
          $('#partnerDrawing').collapse('show')
        }
      },
      deep: true,
    },
    'histories': {
      handler: function(newVal) {
        if (newVal.length === 0) {
          $('#partnerHistoryDrawing').collapse('hide')
        } else if (this.changeHistories.length === 0) {
          $('#partnerHistoryDrawing').collapse('hide')
        } else {
          $('#partnerHistoryDrawing').collapse('show')
        }
      },
      deep: true,
    },
  },
}
</script>

<style>

</style>
